import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useTaskLogsQuery(taskId: string) {
  return useQuery({
    queryKey: ['task-logs', taskId],
    refetchInterval: 5000,
    queryFn: async () => {
      return fetch(
        `/analysis/tasks/${taskId}/logs`,
        {
          method: 'GET'
        },
        schemas.AnalysisLogsDto
      );
    }
  });
}
